(function () {
  'use strict';

  angular
    .module('slipAllowanceReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('slipAllowanceReport', {
        url: '/slip-allowance-report',
        views: {
          'slipAllowanceReportView': {
            templateUrl: 'slip-allowance-report/views/slip-allowance-report.tpl.html',
            controller: 'SlipAllowanceReportCtrl',
            controllerAs: 'slipAllowanceReport'
          }
        }
      });
  }
}());
